export default __webpack_public_path__ + "static/media/arrowDoenOrderId.56f376fd.svg";